import { Donut } from "../../../../src/components/Donut";
import * as React from 'react';
export default {
  Donut,
  React
};